import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { syncCheckoutSession } from '../services/billingClient';
import { clearSignupPlanIntent } from '../utils/signupPlanIntent';
import { toUserMessage } from '../utils/asyncReliability';

const StripeReturn = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Finalizing your subscription...');
  const [error, setError] = useState('');
  const [isRetrying, setIsRetrying] = useState(false);

  const runSync = async () => {
    const q = new URLSearchParams(location.search);
    const sessionId = q.get('session_id');
    const canceled = q.get('checkout') === 'canceled';

    if (canceled) {
      navigate('/dashboard/settings?plans=1&checkout=canceled', { replace: true });
      return;
    }
    if (!sessionId) {
      navigate('/dashboard/settings?plans=1', { replace: true });
      return;
    }

    setError('');
    try {
      await syncCheckoutSession(sessionId);
      clearSignupPlanIntent();
      navigate('/dashboard/settings?plans=1&welcome=pro', { replace: true });
    } catch (e) {
      setError(toUserMessage(e, 'We could not confirm your payment. Please check your card details and try again.'));
      setMessage('Payment could not be verified.');
    }
  };

  useEffect(() => {
    void runSync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-sm text-center">
        <h1 className="text-lg font-semibold text-slate-900">One moment...</h1>
        <p className="mt-2 text-sm text-slate-600">{message}</p>
        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
        {error && (
          <button
            type="button"
            disabled={isRetrying}
            onClick={async () => {
              setIsRetrying(true);
              try {
                await runSync();
              } finally {
                setIsRetrying(false);
              }
            }}
            className="mt-4 rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary-dark disabled:opacity-60"
          >
            {isRetrying ? 'Retrying…' : 'Retry sync'}
          </button>
        )}
      </div>
    </div>
  );
};

export default StripeReturn;
